import type {
  QuickCheckoutRequest,
  QuickCheckoutResponse,
} from '@iheartjane/data-access';
import { useCreateQuickCheckout } from '@iheartjane/data-access/react-query';
import { useMfa } from '@iheartjane/menu';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { getJwt } from '@jane/shared/auth';
import { monolithPaths } from '@jane/shared/util';

export const useSubmitQuickCheckout = () => {
  const navigate = useNavigate();
  const { launch, requiresMfa } = useMfa();

  const {
    mutate: createCheckout,
    isPending,
    isError,
    reset,
  } = useCreateQuickCheckout({
    onSuccess: (data: QuickCheckoutResponse) =>
      navigate(monolithPaths.reservation(data.reservation.id)),
  });

  const handleCheckout = useCallback(
    (props: QuickCheckoutRequest) => {
      const jwt = getJwt();
      const shouldMfa = requiresMfa();

      if (shouldMfa) {
        launch({
          onSuccess: () => createCheckout({ ...props, jwt }),
          newPhone: undefined,
        });
        return;
      } else {
        createCheckout({ ...props, jwt });
      }
    },
    [createCheckout, launch, requiresMfa]
  );

  return {
    submit: handleCheckout,
    isCheckingOut: isPending,
    hasCheckoutError: isError,
    resetCheckoutError: reset,
  };
};
